module.exports = __webpack_public_path__ + "static/Equipment-31b3e177b7f79c8df5cd78900a1ab1fa.png";